import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject } from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { MyPromise } from '../interceptors/myPromise.service';
const BASEURL = `${environment.baseEndpoint}/messaging`;

@Injectable({ providedIn: 'root' })

export class MessagingService {

  currentMessage = new BehaviorSubject(null);

  constructor(
    private firestore: AngularFirestore,
    private http: HttpClient,
    private myPromise: MyPromise,
    private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      },
    );
  }

  /**
   * update token in firebase database
   *
   * @param token token as a value
   */
  updateToken(token) {
    return this.myPromise.to(this.http.post(BASEURL, {token}));
    // we can change this function to request our backend service
  }

  /**
   * request permission for notification from firebase cloud messaging
   */
  requestPermission() {
    this.angularFireMessaging.requestToken.subscribe(
      async (token) => {
        const [err] = await this.updateToken(token);
        if (err) return err;
        // return console.error('Store Token', response);
      },
      (err) => {
        return err
        // console.error('no disponible para pedir permiso guapo.', err);
      },
    );
  }

  getNotificationsFirestore(userId: string) {
    return this.firestore.collection('notifications', query => {
      return query.where('userId', '==', userId).where('read', '==', false).orderBy('date').limit(10);
    }).snapshotChanges();
  }

  getNotifications() {
    return this.myPromise.to(this.http.get(`${BASEURL}/notifications`));
  }


  changeStatusReadNotification(notificationId: string) {
    return this.myPromise.to(this.http.put(`${BASEURL}/notification/${notificationId}/read`, {}));
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload: any) => {
        // console.error('new message received. ', payload);
        const NotificationOptions = {
          body: payload.notification.body,
          data: payload.data,
          icon: payload.notification.icon,
          badge: payload.notification.icon,
          image: payload.notification.icon,
        };
        // console.error(NotificationOptions);
        navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope').then(registration => {
          return registration.showNotification(payload.notification.title, NotificationOptions);
        });
        this.currentMessage.next(payload);
      });
  }
}
